var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommvault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1L2.29077 6.60688V17.3931L12 23L21.7093 17.3931V6.60688L12 1ZM20.024 16.423L11.9918 21.0598L3.95968 16.423V7.57698L11.9918 2.94021L20.024 7.57698V16.423Z",
    fill: "#FF4A6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.441 18.8255C11.441 18.9077 11.3506 18.957 11.2766 18.9159L5.62036 15.6521C5.5217 15.5945 5.45593 15.4876 5.45593 15.3725V9.05864C5.45593 8.97643 5.54637 8.9271 5.62036 8.9682L11.2766 12.232C11.3752 12.2896 11.441 12.3965 11.441 12.5116V18.8255ZM17.6233 8.10498L12.2138 11.229C12.0822 11.303 11.9178 11.303 11.7863 11.229L6.37671 8.10498C6.30272 8.06387 6.30272 7.95699 6.37671 7.91589L11.7863 4.79182C11.9178 4.71783 12.0822 4.71783 12.2138 4.79182L17.6233 7.91589C17.6973 7.95699 17.6973 8.06387 17.6233 8.10498ZM17.6233 16.0796L12.7153 18.9159C12.6413 18.957 12.5509 18.9077 12.5509 18.8255V13.161C12.5509 13.0788 12.6413 13.0295 12.7153 13.0706L17.6233 15.9069C17.6973 15.9398 17.6973 16.0385 17.6233 16.0796Z",
    fill: "#FF4A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommvault);
export default __webpack_public_path__ + "static/media/Commvault.eae7986f1a46dd8fbd42abbf1785ee57.svg";
export { ForwardRef as ReactComponent };